import { Tkv2ReferenceViewModule } from '../../modules/referenceView/Tkv2ReferenceViewModule.tsx';

export const Tkv2MlsDataSheetRouteElement = () => {
  return <Tkv2ReferenceViewModule isPopout dataSheet="mls-listing" />;
};
